import reducer from './reducers/index'
import { settings } from '../../../settings/settings-util'

export default class IvaAvailability 
{
    constructor(passedSettings) 
    {
        this._settings = passedSettings || settings;
    }

    getReducer() 
    {
         return reducer;
    }

    initialize(store) 
    {
        this._store = store;
        
        this.globalObjectName = this._settings.launchPoint.globalObjectName;

        this.isTimeBasedEnabled = this._settings.IvaAvailability.enableTimeBasedAvailability;

        if(!window[this.globalObjectName])
        {
            window[this.globalObjectName] = {};
        }
        window[this.globalObjectName].clientAvailable = false;

        //this uses local time and that's not reliable becuase it is affected by current location - Arizona - DST is cacluated incorrectly since they don't follow
        Date.prototype.stdTimezoneOffset = function() 
        {
            var jan = new Date(this.getFullYear(), 0, 1);
            var jul = new Date(this.getFullYear(), 6, 1);
            return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
        }

        Date.prototype.isDst = function() 
        {
            return this.getTimezoneOffset() < this.stdTimezoneOffset();
        }
    }

    PerformAvailCheck(initPromise)
    {
        initPromise.then(
            () => 
            {
                if(this.isTimeBasedEnabled)    
                {
                    if(this.isUnderOperatingHours())        
                        window[this.globalObjectName].clientAvailable = true;
                }
                else
                {
                    window[this.globalObjectName].clientAvailable = true;
                }
            }   
        );

        return initPromise;
    }

    isUnderOperatingHours()
    {
        //availability configuration : 
        //M-F 9 AM to 9:30 PM - EST
        //M-S 13 to 1 - UTC

        let underOperatingHours = false;
        let underOperatingDays = false;
        let underfullDay = false;

        let startHourUtc = this._settings.IvaAvailability.startHour;
        let startMinUtc = this._settings.IvaAvailability.startMinute;
        let endHourUtc = this._settings.IvaAvailability.endHour;
        let endMinUtc = this._settings.IvaAvailability.endMinute;

        let startOperatingDay = this._settings.IvaAvailability.startOperatingDay; //Monday
        let endOperatingDay = this._settings.IvaAvailability.endOperatingDay; //Saturday

        let utcDate = new Date();

        //TODO: This is a temporary workaround - this code MUST be moved to server side before DST start of 2018
        if (!this.isDst())
        {
            startHourUtc = this._settings.IvaAvailability.startHour + 1;
            endHourUtc = this._settings.IvaAvailability.endHour + 1;
        }

        let currentDay = utcDate.getUTCDay();


        /*
            Cases
            Day     Hour    Min     --->    Result
            5       12      0       --->    NotAvailable
            6       23      51      --->    NotAvailable
            6       1       05      --->    Available
            3       17      50      --->    Available
            4       23      45      --->    Available
            4       1       29      --->    Available  
            2       9       29      --->    NotAvailable  
        */
        

        if(currentDay >= startOperatingDay && currentDay <= endOperatingDay)
            underOperatingDays = true;

        if (underOperatingDays)
        {
            let currentHourUtc = utcDate.getUTCHours();
            let currentMinUtc = utcDate.getUTCMinutes();

            //Above starting hours 
            if(currentHourUtc >= startHourUtc && currentMinUtc >= startMinUtc) 
            {
                if (currentHourUtc <= 23 && currentMinUtc <= 59)
                {
                    underfullDay = true;
                    underOperatingHours = true;
                }
            }  

            //EST Friday would be Saturday UTC after 
            if (!underfullDay)
            {
                if(currentDay !== startOperatingDay)
                {
                    //Below ending hours - since we are overlapping on the day
                    if (currentHourUtc < endHourUtc)
                    {
                        underOperatingHours = true;
                    }
                    else if (currentHourUtc === endHourUtc)
                    {
                        if(currentMinUtc <= endMinUtc)
                            underOperatingHours = true;
                    }
                }
            }
            else if (currentDay === endOperatingDay)
            {
                underOperatingHours = false;
            }
        }
          
        return underOperatingHours;
    }

    isDst()
    {
        //Since our configuration is in UTC, we must convert both the dates to UTC before comparison
        
        let dstStartDate = new Date(this._settings.IvaAvailability.dstStartDate);
        let dstEndDate = new Date(this._settings.IvaAvailability.dstEndDate);

        let currentDate = new Date();

        let dstStartDateUtc = dstStartDate.getTime();
        let dstEndDateUtc = dstEndDate.getTime();

        let currentDateUtc = currentDate.getTime();

        return currentDateUtc >= dstStartDateUtc && currentDateUtc < dstEndDateUtc 
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/iva-availability/src/iva-availability.js